var $aeaf8a1d8cee2bf2$exports = {};
$aeaf8a1d8cee2bf2$exports = {
    "collectionLabel": `Sugerencias`
};


export {$aeaf8a1d8cee2bf2$exports as default};
//# sourceMappingURL=es-ES.mjs.map
